import { useState, useEffect } from 'react';
import { getTrips, addTrip, updateTrip, deleteTrip, Trip, registerForTrip as registerForTripQuery } from '@/lib/firebase/queries/trips';
import { toast } from 'sonner';

export function useTrips() {
  const [trips, setTrips] = useState<Trip[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchTrips = async () => {
    setLoading(true);
    try {
      const data = await getTrips();
      setTrips(data);
    } catch (error) {
      toast.error('Failed to fetch trips');
    } finally {
      setLoading(false);
    }
  };

  const handleAddTrip = async (trip: Omit<Trip, 'id'>) => {
    try {
      await addTrip(trip);
      await fetchTrips();
      toast.success('Trip added');
    } catch (error) {
      toast.error('Failed to add trip');
    }
  };

  const handleUpdateTrip = async (id: string, data: Partial<Trip>) => {
    try {
      await updateTrip(id, data);
      await fetchTrips();
      toast.success('Trip updated');
    } catch (error) {
      toast.error('Failed to update trip');
    }
  };

  const handleDeleteTrip = async (id: string) => {
    try {
      await deleteTrip(id);
      await fetchTrips();
      toast.success('Trip deleted');
    } catch (error) {
      toast.error('Failed to delete trip');
    }
  };

  const handleRegisterForTrip = async (tripId: string, userId: string) => {
    try {
      await registerForTripQuery(tripId, userId);
      await fetchTrips();
      toast.success('Registered for trip');
    } catch (error) {
      toast.error('Failed to register for trip');
    }
  };

  useEffect(() => {
    fetchTrips();
  }, []);

  return {
    trips,
    loading,
    refreshTrips: fetchTrips,
    addTrip: handleAddTrip,
    updateTrip: handleUpdateTrip,
    deleteTrip: handleDeleteTrip,
    registerForTrip: handleRegisterForTrip
  };
} 